import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    transition: 'all 100ms ease-in-out',
  },
  child: {
    marginTop: 15,
    backgroundColor: theme.palette.details,
    width: '100%',
    borderRadius: theme.shape.borderRadius * 2,
    padding: 15,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius - 1,
  },
  bottomContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 16,
  },
  text: {
    color: theme.palette.text.primary,
    fontSize: 13,
  },
}))

export default useStyles
